if (typeof document !== 'undefined' && !document.head.querySelector("style[data-wp-hash='fe01a7e62f']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "fe01a7e62f");
	style.appendChild(document.createTextNode(".boot-save-button{width:100%}"));
	document.head.appendChild(style);
}
